import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
export const ChangeLocationLink = styled(Typography)(
  ({ theme }) => `

  cursor: pointer;
  color:  ${theme.DS_palette.buttons.enabled};
`,
);
